//@ts-nocheck

'use client'

import React from "react";

import * as S from './CardSquare.styles'

import { Paragraph } from "../../atoms/Typography/Typography.component";
import LinkWrapper from "../../atoms/LinkWrapper/LinkWrapper.component";

import Image from 'next/image'

interface CardSquareProps {
  title: string
  image: {
    url: string
    alt: string
  }
  href: string
  paragraph?: string
  parentColorScheme: string
  withBackground: boolean
}

const CardSquare = ({ title, image, href, paragraph, parentColorScheme, withBackground }: CardSquareProps) => {
  
  return (
    <LinkWrapper href={href}>
      <S.CardSquare href={href} colorScheme={parentColorScheme} withBackground={withBackground}>
        <S.CardSquareImage>
          <Image src={image?.url} alt={image?.alt} fill/>
        </S.CardSquareImage>
        <Paragraph content={title} typo={'headingMD'} weight={'medium'} />
        { paragraph ? (
          <Paragraph content={paragraph} typo={'paragraphMD'} weight={'regular'} />
        ) : null}
      </S.CardSquare>
    </LinkWrapper>
  )
}

export default CardSquare